import styled, { css } from 'styled-components';

import { LoyaltyBackground } from '../loyalty-background';

const IncentivesGridDefault = (incentiveSelected: boolean) => css`
  display: flex;
  width: 200vw;
  transition: 0.475s;
  height: 100%;
  ${incentiveSelected &&
  css`
    transform: translateX(-100vw);
  `};
  ${Styles.desktop`
    transform: unset;
    width: unset;
    display: grid;
    grid-template-columns: 450px 1fr;
  `}
`;

const IncentivesGridWidget = css`
  display: block;
`;

export const IncentivesGrid = styled(LoyaltyBackground)<{
  incentiveSelected: boolean;
  isWidget: boolean;
  isCarousel: boolean;
}>`
  ${p => (p.isWidget ? IncentivesGridWidget : IncentivesGridDefault(p.incentiveSelected))}
`;

export const IncentiveItemsContainer = styled.ul`
  padding: 0;
`;

export const IncentiveList = styled.ul`
  padding: 0;
  margin: 0;
  max-height: 100%;
  transition: 0.25s;
  scroll-behavior: smooth;
  overflow-y: auto;
  width: 100vw;

  ${Styles.desktop`
    width: unset;
  `}
`;

export const IncentiveDetails = styled.div`
  border-left: 1px solid ${Styles.color.grey.four};
`;

export const LoadingAnimationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 3rem;
`;
